import { TestimonialType } from '../types';
import { SET_BBPS_HOME_PAGE_DATA, SET_BBPS_TESTIMONIAL_DATA } from './type';

const initialState: {
  homepage: any;
  testimonials: TestimonialType[];
  billspage: any[];
} = {
  homepage: null,
  testimonials: null,
  billspage: null,
};

function bbpsReducer(state = initialState, action) {
  const { type, data } = action;

  switch (type) {
    case SET_BBPS_HOME_PAGE_DATA:
      state.homepage = data;
      return state;
    case SET_BBPS_TESTIMONIAL_DATA:
      state.testimonials = data;
    default:
      return state;
  }
}

export default bbpsReducer;
